import React, { useEffect, useState } from "react";
import { Button, Form } from "reactstrap";
import { StatusDataUMK } from "../../../../Constant/StatusData";
import { SelectionField } from "../../../../CommonElements";
import FormModal from "../../../../Layout/Components/FormModal";
import { updateStatusUMK } from "../services";

const EditStatusUMKModal = ({
  editStatusModalOpen,
  toggleEditStatusModal,
  selectedUMK,
  refreshUMK,
  axiosInstance,
}) => {
  const [waitingForSubmit, setWaitingForSubmit] = useState(false);
  const [formData, setFormData] = useState({
    id_unit_kerja: "",
    id_umk: "",
    id_status_umk: "",
  });

  useEffect(() => {
    if (selectedUMK) {
      setFormData({
        id_unit_kerja: selectedUMK.id_unit_kerja,
        id_umk: selectedUMK.id_umk,
        id_status_umk: selectedUMK.id_status_umk,
      });
    }
  }, [selectedUMK]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      setWaitingForSubmit(true);
      await updateStatusUMK(axiosInstance, selectedUMK.pk, formData).then(
        () => {
          toggleEditStatusModal();
          refreshUMK();
          let timer = setTimeout(() => setWaitingForSubmit(false), 1000);
          return () => clearTimeout(timer);
        }
      );
    } finally {
      setWaitingForSubmit(false);
    }
  };

  return (
    <FormModal
      isOpen={editStatusModalOpen}
      toggle={toggleEditStatusModal}
      title={"Edit Status UMK"}
      footerButtons={
        <>
          <Button
            color="primary"
            onClick={handleSubmit}
            disabled={waitingForSubmit}
          >
            Submit
          </Button>
          <Button color="secondary" onClick={toggleEditStatusModal}>
            Cancel
          </Button>
        </>
      }
    >
      <Form>
        <SelectionField
          state={formData}
          label={"Status UMK"}
          name={"id_status_umk"}
          options={StatusDataUMK}
          optionsName={"nama_status"}
          optionsValue={"id"}
          onChange={handleChange}
          value={formData.id_status_umk}
        />
      </Form>
    </FormModal>
  );
};

export default EditStatusUMKModal;
